// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.HomeV2 = (await import('./pages/HomeV2')).HomeV2;
    Components.Balance = (await import('./pages/Balance')).Balance;
    Components.List = (await import('./pages/List')).List;
    Components.ThirdPartyList = (await import('./pages/ThirdPartyList')).ThirdPartyList;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  homeV2: {
    name: 'HomeV2',
    componentName: 'HomeV2',
    chunk: () => import('./pages/HomeV2'),
    get component() {
      return ssr
        ? serverPages.HomeV2
        : currentRouteName === 'HomeV2'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.HomeV2 })));
    },
    path: '/:context?/gift-cards/p/:name?/:productLineId?/:configurationId?',
    channel: null,
  },
  balance: {
    name: 'Balance',
    componentName: 'Balance',
    chunk: () => import('./pages/Balance'),
    get component() {
      return ssr
        ? serverPages.Balance
        : currentRouteName === 'Balance'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Balance })));
    },
    path: '/:context?/gift-cards/balance',
    channel: null,
  },
  list: {
    name: 'List',
    componentName: 'List',
    chunk: () => import('./pages/List'),
    get component() {
      return ssr
        ? serverPages.List
        : currentRouteName === 'List'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.List })));
    },
    path: '/:context?/gift-cards/list',
    channel: null,
  },
  thirdParty: {
    name: 'ThirdPartyList',
    componentName: 'ThirdPartyList',
    chunk: () => import('./pages/ThirdPartyList'),
    get component() {
      return ssr
        ? serverPages.ThirdPartyList
        : currentRouteName === 'ThirdPartyList'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ThirdPartyList })));
    },
    path: '/:context?/gift-cards/specialty-cards',
    channel: null,
  },
});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
};